import { CSSObject } from '@emotion/react'

const getBaseStyles = (isExpanded: boolean): CSSObject => ({
  display: 'flex',
  flexDirection: 'column',
  width: isExpanded ? 900 : 484,
  minHeight: 667,
  height: isExpanded ? 'unset' : 750,
})

const styles = {
  getBaseStyles,
}

export { styles }
